<template>
  <div>
    <container-headline
      :headline="$t('global.familyinformation')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="familie.hofangaben.stellvertretung"
                  class="form-control"
                  :placeholder="$t('global.namefunctionroleyear')"
                  :readonly="!editable"
                />
                <label>{{ $t("global.responsibleabsence") }}</label>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="form-group">
                <input
                  type="number"
                  min="0"
                  v-model.trim="familie.hofangaben.anzahlKinderTotal"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.totalchildren") }}</label>
              </div>
            </div>
            <div
              v-if="familie.hofangaben.anzahlKinderTotal > 0"
              class="col-xl-3"
            >
              <div class="form-group">
                <input
                  type="number"
                  min="0"
                  :max="familie.hofangaben.anzahlKinderTotal"
                  v-model.trim="familie.hofangaben.anzahlKinderHof"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                  @input="updateKinderArray"
                />
                <label>{{ $t("global.childrenonfarm") }}</label>
              </div>
            </div>
          </div>
          <div
            v-show="
              familie.hofangaben.anzahlKinderTotal > 0 &&
              familie.hofangaben.anzahlKinderHof > 0
            "
          >
            <div
              class="row"
              v-for="(kind, index) in familie.kinder"
              :key="index"
            >
              <div class="col-xl-9">
                <div class="form-group">
                  <v-select
                    v-model="kind.geschlecht"
                    label="bezeichnung"
                    :options="geschlechter"
                    :disabled="!editable"
                    :placeholder="$t('global.gender')"
                  >
                    <span slot="no-options">{{
                      $t("global.taptosearch")
                    }}</span>
                  </v-select>
                  <label>{{ $t("global.gender") }}</label>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <input
                    min="0"
                    type="number"
                    v-model.trim="kind.jahrgang"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                  />
                  <label>{{ $t("global.year") }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <input
                  v-model.trim="familie.hofangaben.anderePersonenHof"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.otherpeoplelivingonthefarm") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <input
                  v-model.trim="familie.hofangaben.organisationsauswahl"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.otherorganisations") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-check col-xl-6" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="familie.hofangaben.istRaucherHaushalt"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.smokinginthehouse") }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "FirmaFamilienangabenNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    familie: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    geschlechter: {
      get() {
        return this.$store.state.geschaeftspartner.geschlechter;
      },
    },
  },
  watch: {},
  created() {},
  methods: {
    updateKinderArray() {
      if (
        this.familie.hofangaben.anzahlKinderHof &&
        this.familie.hofangaben.anzahlKinderHof > 0
      ) {
        while (
          this.familie.kinder.length < this.familie.hofangaben.anzahlKinderHof
        ) {
          this.familie.kinder.push({ jahrgang: null, geschlecht: null });
        }
        while (
          this.familie.kinder.length > this.familie.hofangaben.anzahlKinderHof
        ) {
          this.familie.kinder.pop();
        }
      } else {
        while (this.familie.kinder.length > 0) {
          this.familie.kinder.pop();
        }
      }
    },
  },
};
</script>
